module.exports = __webpack_public_path__ + "img/1548499105.9d65f2b2.jpg";